import React, { useEffect, useState } from 'react';
import {BrowserRouter, Routes as Router, Route} from 'react-router-dom';
import HomePage from "./components/HomePage.jsx";
import InitialPage from './components/InitialPage.jsx';
import './assets/css/colors.css'
import './assets/css/fonts.css'
import SecondMobPage from './components/SecondMobPage.jsx';
import BoasVindas from './components/BoasVindas/BoasVindas.jsx';
function Routes(){

    const [ativaResp, setAtivaResp] = useState(null)

    useEffect(()=>{
        if (ativaResp == null){
            if (window.matchMedia("(max-width: 767px)").matches){
            setAtivaResp(true)
            }else{
                setAtivaResp(false)
            }
        }
    },[])

    console.log(ativaResp)
    return(
        <BrowserRouter>
            <Router>
                <Route path="/" element={ativaResp && false ?  <InitialPage ativaResp={ativaResp}/> : <HomePage  ativaResp={ativaResp}/>}/>
                <Route path="/Inicial" element={<SecondMobPage ativaResp={ativaResp}/>}/>
                <Route path="/HomePage" element={<HomePage  ativaResp={ativaResp}/>}/>
                <Route path="/BoasVindas" element={<BoasVindas  ativaResp={ativaResp}/>}/>
            </Router>
        </BrowserRouter>
    );
 };
export default Routes;

